export enum MessageRecipientTypes {
    DEFAULT = 'default',
    CONSULTANT = 'consultant',
    PATIENT = 'patient',
}
